import { QueryClient } from 'react-query';

/**
 * React Query Client Configuration
 *
 * Default configuration for React Query with sensible defaults:
 * - Queries are considered stale after 5 minutes
 * - Cache time is 10 minutes
 * - No automatic retries on error
 * - Refetch on window focus disabled by default
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: false,
    },
  },
});
